import { render } from "./BindingWebchat.vue?vue&type=template&id=8f409e8a"
import script from "./BindingWebchat.vue?vue&type=script&lang=js"
export * from "./BindingWebchat.vue?vue&type=script&lang=js"

import "./BindingWebchat.vue?vue&type=style&index=0&id=8f409e8a&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__